const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://offersshopping.com';

export default function TestimoniosSeoJsonLd() {
  const breadcrumb = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Inicio', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: 'Testimonios', item: `${SITE_URL}/testimonios` },
    ],
  };

  const aggregateRating = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Digital Licence Store',
    url: SITE_URL,
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.9',
      reviewCount: '847',
      bestRating: '5',
      worstRating: '1',
    },
    review: [
      {
        '@type': 'Review',
        author: { '@type': 'Person', name: 'Carlos M.' },
        reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5' },
        reviewBody: 'Excelente servicio, recibí mi licencia de Windows 11 PRO en minutos. Totalmente recomendado.',
        datePublished: '2025-06-15',
      },
      {
        '@type': 'Review',
        author: { '@type': 'Person', name: 'Laura P.' },
        reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5' },
        reviewBody: 'Compré Office 2024 y funcionó perfectamente. El soporte por WhatsApp fue muy rápido.',
        datePublished: '2025-05-20',
      },
      {
        '@type': 'Review',
        author: { '@type': 'Person', name: 'Andrés R.' },
        reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5' },
        reviewBody: 'Precios increíbles y entrega inmediata. Ya llevo 3 compras y siempre perfectas.',
        datePublished: '2025-04-10',
      },
    ],
  };

  const webpage = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Testimonios y Opiniones - Digital Licence Store Colombia',
    description: 'Lee las opiniones verificadas de más de 847 clientes satisfechos con sus licencias de software originales. Calificación promedio 4.9/5.',
    url: `${SITE_URL}/testimonios`,
    inLanguage: 'es-CO',
    isPartOf: { '@type': 'WebSite', name: 'Digital Licence Store', url: SITE_URL },
    breadcrumb: breadcrumb,
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(aggregateRating) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webpage) }} />
    </>
  );
}
